export const SET_AVATAR = "sagas/avatar/SET_AVATAR";
